import {
  IndicatorDetails,
  SectionIndicators,
} from '../../../../ReportBuilder/Components/IndicatorDetails/utils';
import {
  findForecastMatches,
  getForecast,
  stripCommas,
} from './forecastValidationUtils';

export type ReachSucceedMatchField = 'forecast' | 'finalForecast';

export interface ReachSucceedMatch {
  indicator: IndicatorDetails;
  field: ReachSucceedMatchField;
  value: string;
  matches: IndicatorDetails[];
}

export interface ReachSucceedMatchInput {
  impactDetails: SectionIndicators;
  hideForecast: boolean;
  hideFinalForecast: boolean;
}

export const REACH_SUCCEED_MATCH_TITLE = 'Are these numbers accurate?';

export const REACH_SUCCEED_MATCH_MESSAGE =
  'Success and reach are showing the same number, which means everyone reached also succeeds. Is this accurate? If not, please revise.';

export const REACH_SUCCEED_MATCH_NOTE_PLACEHOLDER =
  'Please explain why everyone reached also succeeds.';

export const getReachSucceedMatches = ({
  impactDetails,
  hideForecast,
  hideFinalForecast,
}: ReachSucceedMatchInput): ReachSucceedMatch[] => {
  const reachIndicators = impactDetails.reach || [];
  const succeedIndicators = impactDetails.succeed || [];

  if (reachIndicators.length === 0 || succeedIndicators.length === 0) {
    return [];
  }

  const results: ReachSucceedMatch[] = [];

  for (const indicator of succeedIndicators) {
    const forecastValue = stripCommas(getForecast(false, indicator));
    const finalForecastValue = stripCommas(getForecast(true, indicator));

    const forecastMatches =
      !hideForecast && forecastValue
        ? findForecastMatches(reachIndicators, forecastValue, t => t.forecast)
        : [];
    if (forecastMatches.length > 0) {
      results.push({
        indicator,
        field: 'forecast',
        value: forecastValue,
        matches: forecastMatches,
      });
    }

    const finalForecastMatches =
      !hideFinalForecast && finalForecastValue
        ? findForecastMatches(
            reachIndicators,
            finalForecastValue,
            t => t.finalForecast,
          )
        : [];
    if (finalForecastMatches.length > 0) {
      results.push({
        indicator,
        field: 'finalForecast',
        value: finalForecastValue,
        matches: finalForecastMatches,
      });
    }
  }

  return results;
};
